import { createSlice } from '@reduxjs/toolkit'
import helper from '../../Helper';
import API from "../../APIS/index";

let frontUrl = helper.FrontBackendURL();

const initialState = {
    googleLoginRes: [],
    faceBookLoginRes: [],
    appleLoginRes: [],
    error: "",
}

const socialLoginSlice = createSlice({
    name: 'socialLogin',
    initialState,
    reducers: {
        google: (state, action) => {
            state.googleLoginRes = action.payload
        },
        facebook: (state, action) => {
            state.faceBookLoginRes = action.payload
        },
        apple: (state, action) => {
            state.appleLoginRes = action.payload
        },
    }
})

export const { google, facebook, apple } = socialLoginSlice.actions;
export default socialLoginSlice.reducer;



export const googleLogin = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.SOCIAL_GOOGLE_LOGIN}`, data);
            callback(response);
            dispatch(google(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

export const appleLogin = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.SOCIAL_APPLE_LOGIN}`, data);
            callback(response);
            dispatch(apple(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };

export const faceBookLogin = (data, callback = () => { }) =>
    async dispatch => {
        try {
            const response = await helper.PostData(`${frontUrl}/${API?.SOCIAL_FACEBOOK_LOGIN}`, data);
            callback(response);
            dispatch(facebook(response.data))
            return response.data
        } catch (e) {
            return console.error(e.message)
        }
    };